import { Pipe, PipeTransform } from '@angular/core';

import { ActivityHistory } from '../../models';

@Pipe({
  name: 'sortRecords'
})
export class SortRecordsPipe implements PipeTransform {
  transform(records: ActivityHistory[]) {
    if (!records) return [];

    return records.filter(function (el) {
      return el != null;
    }).sort(({ timestamp: t1 }, { timestamp: t2 }) => +t2 - +t1);
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/sort-records.pipe.ts